export default __webpack_public_path__ + "static/media/building.111b0d09.svg";